module.exports = __webpack_public_path__ + "static/media/download_button.3871ee49.jpeg";